import { DataManagement } from "@/components/dashboard/superadmin/DataManagement"
import { Page, PageHeader } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"

const DataPage = () => (
  <SuperAdminLayout>
    <Page>
      <PageHeader title="Dados e backups" description="Consumo do banco e do storage frente aos limites do plano." />
      <DataManagement />
    </Page>
  </SuperAdminLayout>
)

export default DataPage
